import { render, staticRenderFns } from "./PleatingoverviewPage.vue?vue&type=template&id=d8a57bd4"
import script from "./PleatingoverviewPage.vue?vue&type=script&lang=js"
export * from "./PleatingoverviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports